import React, { useEffect, useState } from "react";
import { ThreeCircles } from "react-loader-spinner";
import { useParams, useNavigate } from "react-router";
const PaymentCompleted = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { sessionId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (sessionId) {
      fetch(
        `https://us-central1-iou-hub-9d38f.cloudfunctions.net/PullSessionInformationFromStripe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
          body: JSON.stringify({
            data: {
              sessionId: sessionId,
            },
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            if (window.ReactNativeWebView) {
              // send data object to React Native (only string)
              window.ReactNativeWebView.postMessage(JSON.stringify(data));
            }
          } else {
            navigate("/error");
          }
        })
        .catch((err) => {
          console.log(err);
          navigate("/error");
        });
    } else {
      navigate("/error");
    }
  }, [sessionId]);
  return (
    <div className="payment-completed-container">
      {isLoading ? (
        <div className="item-details-wrapper">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ThreeCircles
                visible={true}
                height="70"
                width="70"
                color="#000000"
                ariaLabel="three-circles-loading"
                wrapperClass=""
              />
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "#000000",
                }}
              >
                Updating your account...
              </p>
              <p style={{ fontSize: "12px", color: "#000000" }}>
                This page will close automatically when completed
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PaymentCompleted;
